module.exports = __webpack_public_path__ + "img/denonaB2.d47900e7.jpg";